import {
  RECORD_LOAD,
  RECORD_LOAD_SUCCESS,
  RECORDED_DELETE,
  RECORD_ACTION_SUCCESS
} from "./actions";
import {
  GUIDE_LOAD_SUCCESS
} from "../../redux-root/actions";

const initialState = {
  planData: null,
  recordData: null
};

export function recordReducer(state = initialState, action) {
  let data = action.payload;

  switch (action.type) {
    case RECORD_LOAD:
      return {
        ...state,
        planData: null,
        recordData: null
      };

    case RECORD_LOAD_SUCCESS:
      return {
        ...state,
        planData: data.plan,
        recordData: data.recordData
      };

    case RECORD_ACTION_SUCCESS:
      return {
        ...state,
        recordData: data
      };

    case GUIDE_LOAD_SUCCESS:
      return {
        ...state,
        planData: action.plan,
        recordData: action.recorded
      };

    default:
      return state;
  }
}
